import React from 'react';
import { Grid, Checkbox } from 'semantic-ui-react';

import FormField from '~/views/common/FormField';
import Section from '~/views/common/Section';

import { fmt } from '~/utils';


const Settings = () => (
    <Section name="Settings">
        <Grid columns={3} divided stackable container>
            <Grid.Column>
                <FormField control={Checkbox} toggle label="Portal" name="portal" />
                <FormField control={Checkbox} toggle label="Deleted" name="deleted" />
                <FormField control={Checkbox} toggle label="Archived" name="archived" />
                <FormField control={Checkbox} toggle label="Private" name="private" />
                <FormField control={Checkbox} toggle label="Closed" name="closed" />
            </Grid.Column>
            <Grid.Column>
                <FormField control={Checkbox} toggle label={fmt('show_impact_meter')} name="show_impact_meter" />
                <FormField control={Checkbox} toggle label={fmt('allow_offline')} name="allow_offline" />
                <FormField control={Checkbox} toggle label={fmt('allow_private_groups')} name="allow_private_groups" />
                <FormField control={Checkbox} toggle label={fmt('allow_shoutbox')} name="allow_shoutbox" />
                <FormField control={Checkbox} toggle label={fmt('disable_email_notifications')} name="disable_email_notifications" />
            </Grid.Column>
            <Grid.Column>
                <FormField control={Checkbox} toggle label={fmt('offline_opps_require_contact')} name="offline_opps_require_contact" />
                <FormField control={Checkbox} toggle label={fmt('general_opportunity_enabled')} name="general_opportunity_enabled" />
                <FormField control={Checkbox} toggle label={fmt('bypass_content_moderation')} name="bypass_content_moderation" />
                <FormField control={Checkbox} toggle label={fmt('student_graduation_required')} name="student_graduation_required" />
            </Grid.Column>
        </Grid>
    </Section>
);

export default Settings;
